import { URLParameters } from '@/app/common/urlParameters.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import type { DealCard } from '@/app/components/search/utils/buildDealCards/dealCardTypes.ts';

/**
 * APEX price-absorption params to carry onto the next detail URL when switching hotels *from a detail page*
 * (e.g. the map). Read from the chosen hotel's product rate context — the same source getSDPDeeplink uses on
 * the results page — so the new hotel's pricing-id can absorb the shown map price. `remove` also clears any
 * stale apex context from the current URL and drops vcSearchId for APEX hotels (not a valid Vacation Catalog
 * id), mirroring the results deeplink. (MPH-634)
 */
export const getApexNavParams = (dealCard: DealCard | undefined): { params: SearchParams; remove: URLParameters[] } => {
  const rate = dealCard?.product?.rate;
  const isApex = !!rate?.flags?.apex;
  return {
    params: {
      ...(rate?.context?.priceContext ? { [URLParameters.RATE_PRICE_CONTEXT]: rate.context.priceContext } : {}),
      ...(rate?.context?.signature ? { [URLParameters.RATE_PRICE_CONTEXT_SIGNATURE]: rate.context.signature } : {}),
      ...(isApex ? { [URLParameters.RATE_APEX]: '1' } : {}),
    },
    remove: [
      URLParameters.RATE_APEX,
      URLParameters.RATE_PRICE_CONTEXT,
      URLParameters.RATE_PRICE_CONTEXT_SIGNATURE,
      ...(isApex ? [URLParameters.VC_SEARCH_ID] : []),
    ],
  };
};
